import { docsArticlePath } from "@/lib/docs/parse";
import type { DocsManifest } from "@/lib/docs/types";
import { useOutletContext } from "react-router-dom";
import { Link } from "react-router-dom";

export default function DocsHomePage() {
	const { manifest } = useOutletContext<{ manifest?: DocsManifest }>();

	return (
		<div className="docs-prose max-w-2xl">
			<p className="text-xs font-medium uppercase tracking-[0.16em] text-[var(--docs-muted)]">
				Documentation
			</p>
			<h1 className="mt-2 font-serif text-3xl font-semibold tracking-tight text-[var(--docs-fg)]">
				MotokoDollar docs
			</h1>
			<p className="mt-3 text-[15px] leading-relaxed text-[var(--docs-muted)]">
				Protocol reference for vaults, liquidations, treasury, governance, and
				agents. Separate from the DeFi app and Agent Layer chrome.
			</p>

			{manifest ? (
				<>
					<p className="mt-2 text-xs text-[var(--docs-muted)]">
						v{manifest.version} · updated {manifest.updated}
					</p>
					<div className="mt-6 flex flex-wrap gap-2">
						<Link
							to={docsArticlePath("introduction", "welcome")}
							className="rounded border border-[var(--docs-border)] px-3 py-1.5 text-xs font-medium text-[var(--docs-link)] hover:underline"
						>
							Welcome
						</Link>
						<Link
							to={docsArticlePath("introduction", "quickstart")}
							className="rounded border border-[var(--docs-border)] px-3 py-1.5 text-xs font-medium text-[var(--docs-muted)] hover:text-[var(--docs-fg)]"
						>
							Quickstart
						</Link>
					</div>
					<ul className="mt-8 grid gap-3 sm:grid-cols-2">
						{manifest.sections.map((sec) => (
							<li
								key={sec.id}
								className="rounded-lg border border-[var(--docs-border)] bg-[var(--docs-code-bg)] p-4"
							>
								<p className="font-serif text-base font-semibold text-[var(--docs-fg)]">
									{sec.title}
								</p>
								<p className="mt-1 text-xs text-[var(--docs-muted)]">
									{sec.pages.length} page{sec.pages.length === 1 ? "" : "s"}
								</p>
								<ul className="mt-2 space-y-1">
									{sec.pages.slice(0, 4).map((p) => (
										<li key={p.slug}>
											<Link
												to={docsArticlePath(sec.id, p.slug)}
												className="text-[13px] text-[var(--docs-link)] hover:underline"
											>
												{p.title}
											</Link>
										</li>
									))}
								</ul>
							</li>
						))}
					</ul>
				</>
			) : (
				<p className="mt-6 text-sm text-[var(--docs-muted)]">Loading…</p>
			)}
		</div>
	);
}
